import { render, staticRenderFns } from "./StandardDialog.vue?vue&type=template&id=5328b68e&scoped=true"
import script from "./StandardDialog.vue?vue&type=script&lang=js"
export * from "./StandardDialog.vue?vue&type=script&lang=js"
import style0 from "./StandardDialog.vue?vue&type=style&index=0&id=5328b68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328b68e",
  null
  
)

export default component.exports